import { useState, useEffect } from "react";
import { Outlet } from "react-router-dom";

const STORAGE_KEY = "jobuwin_admin_gate_ok";

function readPassword() {
  return (process.env.REACT_APP_ADMIN_SITE_PASSWORD || "").trim();
}

/** Optional password gate on the admin hostname only. */
export default function AdminPasswordGate() {
  const expected = readPassword();
  const [unlocked, setUnlocked] = useState(false);
  const [value, setValue] = useState("");
  const [error, setError] = useState("");

  useEffect(() => {
    if (!expected) return;
    if (sessionStorage.getItem(STORAGE_KEY) === "1") {
      setUnlocked(true);
    }
  }, [expected]);

  if (!expected) {
    return <Outlet />;
  }

  if (unlocked) {
    return <Outlet />;
  }

  const handleSubmit = (event) => {
    event.preventDefault();
    if (value === expected) {
      sessionStorage.setItem(STORAGE_KEY, "1");
      setUnlocked(true);
      setError("");
    } else {
      setError("That password is not correct.");
    }
  };

  return (
    <main className="preview-gate-page">
      <div className="preview-gate-card">
        <h1 className="preview-gate-title">Ops access</h1>
        <p className="preview-gate-copy">Enter the site password to continue.</p>
        <form className="preview-gate-form" onSubmit={handleSubmit}>
          <label className="preview-gate-label" htmlFor="admin-gate-password">
            Password
          </label>
          <input
            id="admin-gate-password"
            className="preview-gate-input"
            type="password"
            name="password"
            autoComplete="current-password"
            value={value}
            onChange={(e) => setValue(e.target.value)}
          />
          {error ? (
            <p className="preview-gate-error" role="alert">
              {error}
            </p>
          ) : null}
          <button type="submit" className="preview-gate-submit">
            Continue
          </button>
        </form>
      </div>
    </main>
  );
}
